import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "jps_sale_banner_dismissed";

export const SaleBanner = () => {
  const [sale, setSale] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/settings/sale").then(({ data }) => setSale(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (sale?.active && sessionStorage.getItem(KEY) === sale.banner) setDismissed(true);
  }, [sale]);

  if (!sale?.active || dismissed) return null;

  const close = () => {
    sessionStorage.setItem(KEY, sale.banner);
    setDismissed(true);
  };

  return (
    <div
      className="relative z-[60] w-full text-white"
      style={{ backgroundImage: "linear-gradient(90deg,#0b1f3a 0%,#123a63 50%,#0b1f3a 100%)" }}
      data-testid="sale-banner"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2.5 px-10 py-2.5 text-center">
        <Sparkles className="h-4 w-4 shrink-0 text-brand-teal animate-pulse" />
        <p className="text-sm font-semibold tracking-wide" data-testid="sale-banner-text">{sale.banner}</p>
        <button
          onClick={close}
          aria-label="Dismiss sale banner"
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 text-white/70 transition-colors hover:bg-white/10 hover:text-white"
          data-testid="sale-banner-close"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
